import { ApiError } from '@glomopay/utils';

import type { AnalyticsEventName } from '../constants/analytics-event.constants';
import { API_ENDPOINTS } from '../constants/api-endpoint.constants';
import type { TAnalyticsEventCatalogue, TApiResult } from '../types/analytics-events.types';

import { describeApiFailure } from './describe-api-failure';
import { resolveBackendErrorCode } from './resolve-backend-error-code';

const readBackendErrorCode = (error: unknown): string | undefined =>
  error instanceof ApiError ? resolveBackendErrorCode(error.data?.errorCode, error.code, error.data?.error) : undefined;

export const buildApiBackendProperties = ({
  endpoint,
  status,
  error,
  properties,
}: TApiResult): TAnalyticsEventCatalogue[AnalyticsEventName.INVESTOR_API_BACKEND] => {
  const { apiPath, httpMethod } = API_ENDPOINTS[endpoint];
  const baseProperties = { ...properties, api_path: apiPath, http_method: httpMethod, status };

  if (status === 'succeeded') return baseProperties;

  const { statusCode, failureKind } = describeApiFailure(error);
  const errorCode = readBackendErrorCode(error);

  return {
    ...baseProperties,
    failure_kind: failureKind,
    ...(failureKind === 'http' && { http_status: statusCode }),
    ...(errorCode && { error_code: errorCode }),
  };
};
